let trackingEventAnnotation = ''

export const setTrackingEventAnnotation = (annotation: string) => {
  trackingEventAnnotation = annotation
}

export const track = (
  pixelEvent: string,
  mixpanelEvent: string,
  pixelEventType: string = 'trackCustom'
): void => {
  const pixelEventName = trackingEventAnnotation
    ? `${pixelEvent}--${trackingEventAnnotation}`
    : pixelEvent
  const mixpanelEventName = trackingEventAnnotation
    ? `${mixpanelEvent} --${trackingEventAnnotation}`
    : mixpanelEvent

  fbq(pixelEventType, pixelEventName)
  mixpanel.track(mixpanelEventName)
}
